module.exports = __webpack_public_path__ + "img/mobile.e55781ca.png";